import { render, staticRenderFns } from "./TemplatesToEmailsModal.vue?vue&type=template&id=0b5edaf6&scoped=true"
import script from "./TemplatesToEmailsModal.vue?vue&type=script&lang=js"
export * from "./TemplatesToEmailsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b5edaf6",
  null
  
)

export default component.exports